import { styled } from '@linaria/react'
import { COLOR } from 'vars/color'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const TopPageNotificationSC = styled.div`
  position: fixed;
  top: 0;
  width: 100vw;
  text-align: left;
  z-index: 1000;
  background: var(${COLOR.SURFACE_DARK});
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(${FIXED_INDENTS.INDENT_40});
  padding: var(${FIXED_INDENTS.INDENT_40});

  ${MEDIA.MIN_1240} {
    padding: var(${FIXED_INDENTS.INDENT_40}) var(${FIXED_INDENTS.INDENT_140});
  }
`
